import http from '@axios'

const resource = '/api/v1/classes/change-class'

export default {
  add(classes) {
    return http.post(`${resource}`, classes)
  },
}
